<template>
	<!-- .resetting -->
	<div class="resetting">
		<router-view />
	</div>
	<!-- END:.resetting -->
</template>

<script>
export default {
  name: 'resetting'
}
</script>


// WEBPACK FOOTER //
// Resetting.vue?bef72e60